module.exports = __webpack_public_path__ + "img/table-plus-20x20.9d2e8053.svg";